import { useMemo } from "react";
import { debounce } from "lodash";

const useDebouncedDispatch = (dispatch, delay = 300) => {
  // Use `useMemo` to create a debounced version of `dispatch` only once
  const debouncedDispatch = useMemo(
    () => debounce((action) => dispatch(action), delay),
    [dispatch, delay]
  );

  // Ensure the debounced function is cleaned up on component unmount
  // This avoids memory leaks with lodash's debounce
  useMemo(() => {
    return () => debouncedDispatch.cancel();
  }, [debouncedDispatch]);

  // Return a function that accepts `type` and `payload` for the action
  return (type, payload) => {
    debouncedDispatch({ type, payload });
  };
};

export default useDebouncedDispatch;
